import * as React from 'react';

import { Avatar, cn, withColor } from '@rematter/ui-web';

import { getSessionColorName } from '~/shared/providers/presence/sessionColors';

type FocusPosition = {
  userId: string;
  fieldId: string;
  name?: string;
};

interface FieldFocusIndicatorProps {
  fieldId: string;
  focusPositions: FocusPosition[];
  children: React.ReactNode;
  className?: string;
}

//
// ⚛️ ⚛️ ⚛️ FIELD FOCUS INDICATOR ⚛️ ⚛️ ⚛️
//
export const FieldFocusIndicator = ({
  fieldId,
  focusPositions,
  children,
  className,
}: FieldFocusIndicatorProps) => {
  const focusedUsers = React.useMemo(
    () => focusPositions.filter((p) => p.fieldId === fieldId),
    [focusPositions, fieldId],
  );

  const isActive = focusedUsers.length > 0;
  const primaryUser = focusedUsers[0];

  const sessionColor = primaryUser
    ? getSessionColorName(primaryUser.userId)
    : undefined;

  return (
    <div
      className={cn(
        '@FieldFocusIndicator relative',
        isActive &&
          'rounded-md outline outline-2 -outline-offset-2 outline-custom-color',
        className,
      )}
      style={sessionColor ? withColor(sessionColor) : undefined}
    >
      {isActive && primaryUser && (
        <div className="absolute -top-3 right-2 z-10">
          <Avatar
            name={primaryUser.name ?? 'U'}
            size="sm"
            variant="square"
            color={getSessionColorName(primaryUser.userId)}
          />
        </div>
      )}
      {children}
    </div>
  );
};

export type { FocusPosition };
